import React from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';

export const StepEditor = ({ children, modalHeader, onAccept, onCancel, isValid = true }) => {
  return (
    <Modal open title={modalHeader} width="500px">
      {children}
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          <Button type="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={onAccept} disabled={!isValid}>
            Accept
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
